<template>
    <div class="loan-summary-left">
        <template v-if="loan && ! loan.round_sky_application && ! loan.leads_market_application">
            <!--
                Two branches only — funded vs. not-funded — gated on `isFunded`
                (see resources/js/constants/loanStatus.js, issue #4736).
                Do NOT enumerate sign-up statuses here. New sign-up statuses
                added upstream must continue to render the not-funded branch
                with zero payment / interest / loan language.
            -->
            <template v-if="isFunded">
                <div class="line">Remaining payments</div>
                <div class="line">Next payment</div>
                <div class="line">Scheduled on</div>
                <div class="line">Payment method</div>
            </template>
            <template v-else>
                <!-- TODO(#4736): confirm final copy with @seanmo0123 before merge. -->
                <div class="line">Application status</div>
                <div class="line">Next step</div>
            </template>
        </template>
    </div>
</template>

<style scoped>
    .line:not(:last-child) {
        margin-bottom: 0.75rem;
    }
</style>

<script>
export default {
    name: "LoanSummaryLeft",
    mixins: [
        require('../mixins/InteractsWithLoans').default
    ]
};
</script>